// Module
var code = `<app-address-form-easy id="addressFormAnchor"
                       [property]="property"
                       (invalidCheck)="invalidCheck(\$event.invalidObj)"
                       [disableInputsAddress]="false"
                       [showPropertyNickname]="true"
                       [showEasyAddressInputs]="showEasyAddressInputs"
                       [isLoadingFindMyProperty]="isLoadingFindMyProperty"
                       [setPropertyAddressEvent]="setPropertyAddressSubject.asObservable()">
</app-address-form-easy>`;
// Exports
module.exports = code;